import React, { useState, useEffect } from 'react';
import {
  MDBNavbar,
  MDBContainer,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
} from 'mdb-react-ui-kit';
import { FaBars } from 'react-icons/fa';

const Header = () => {
  const [showNav, setShowNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setShowNav(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
    setShowNav(false);
  };

  return (
    <MDBNavbar
      expand="lg"
      light
      fixed="top"
      style={{
        backgroundColor: scrolled ? '#ffffff' : 'rgba(255, 255, 255, 0.95)',
        boxShadow: scrolled
          ? '0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12)'
          : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <MDBContainer fluid>
        <MDBNavbarBrand
          href="#"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('intro');
          }}
          style={{
            fontWeight: 'bold',
            fontSize: '1.5rem',
            color: '#D27F67',
            letterSpacing: '2px',
          }}
        >
          BITE JOY
        </MDBNavbarBrand>
        <MDBNavbarToggler
          type="button"
          aria-expanded={showNav}
          aria-controls="bitejoy-mobile-nav"
          aria-label="Toggle navigation"
          onClick={() => setShowNav(!showNav)}
        >
          <FaBars />
        </MDBNavbarToggler>

        <div id="bitejoy-mobile-nav" className={`collapse navbar-collapse ${showNav ? 'show' : ''}`}>
          <MDBNavbarNav className="ms-auto mb-2 mb-lg-0" right fullWidth={false}>
            <MDBNavbarItem>
              <MDBNavbarLink
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('intro');
                }}
                style={{ fontWeight: '500', color: '#333', cursor: 'pointer' }}
              >
                Home
              </MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem>
              <MDBNavbarLink
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('products');
                }}
                style={{ fontWeight: '500', color: '#333', cursor: 'pointer' }}
              >
                Products
              </MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem>
              <MDBNavbarLink
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('aboutus');
                }}
                style={{ fontWeight: '500', color: '#333', cursor: 'pointer' }}
              >
                About Us
              </MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem>
              <MDBNavbarLink
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('team');
                }}
                style={{ fontWeight: '500', color: '#333', cursor: 'pointer' }}
              >
                Team
              </MDBNavbarLink>
            </MDBNavbarItem>
          </MDBNavbarNav>
        </div>
      </MDBContainer>
    </MDBNavbar>
  );
};

export default Header;
